module.exports = __webpack_public_path__ + "img/sj_gangjiegoushengchan.a65257ae.jpg";